import React, { Component } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';


import tabletImg from '../images/kiosk.png';

class Tablet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgLoad: false,
    };
  }

  handleChange = () => {
    this.setState({ imgLoad: true });
  }

  render() {
    const {
      tablet, title, orderCounts, index,
    } = this.props;
    const { imgLoad } = this.state;
    return (
      <TabletWrapper className="shadow" to={`/panel/tablet/${tablet.id}`}>
        <Title>{title.length > 39 ? `${title.substr(0, 39)}...` : title}</Title>
        <ContentWrapper>
          <Col md="8">
            <Status>

              <StatusWrapper>
                <StatusTitle>
                  <FormattedMessage id="tablet.orderCount" />
                  :
                </StatusTitle>
                {' '}
                <Count>{orderCounts && orderCounts[index] && orderCounts[index].orders && orderCounts[index].orders}</Count>
              </StatusWrapper>
              <StatusWrapper>
                <StatusTitle>
                  <FormattedMessage id="tablet.orderPrice" />
                  :
                  {' '}
                </StatusTitle>
                {' '}
                <Count>{orderCounts && orderCounts[index] && orderCounts[index].price && orderCounts[index].price.toFixed(2)}</Count>
              </StatusWrapper>
            </Status>
          </Col>
          <Col md="4">
            {
              imgLoad ? '' : <Skeleton height={150} />
            }
            <img
              style={imgLoad ? {} : { display: 'none' }}
              src={tabletImg}
              onLoad={this.handleChange}
              alt=""
            />
          </Col>
        </ContentWrapper>
      </TabletWrapper>
    );
  }
}
Tablet.propTypes = {
  tablet: PropTypes.shape({
    isSambaposActive: PropTypes.number,
    isActive: PropTypes.number,
    isBusy: PropTypes.number,
    id: PropTypes.number,
  }).isRequired,
  orderCounts: PropTypes.shape({
    price: PropTypes.number,
  }).isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

const TabletWrapper = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 150px;
  color: black;
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 20px;
  position: relative;
  text-decoration: none  !important;
  background-color: #efefef;
  img {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
    margin-left: 10px;

  }
  :hover {
    color: black;
  }
`;
const Title = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  text-transform: uppercase;
  height: 50px;
  width: 100%;
  border-bottom: 1px solid #949494;
  font-weight: bold;
`;
const ContentWrapper = styled(Row)`
  display: flex;
  align-items: center;
  padding: 10px 0;
  width: 100%;
`;
const Status = styled.div`
  width: 100%;
`;
const StatusTitle = styled.span`
  font-size: 0.9rem;
  font-weight: bold;
`;
const Count = styled.span`
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CircleContainer = styled.div`
  min-width: 12%;
  max-width: 12%;
  width: 12%;
  min-height: 12%;
  max-height: 12%;
  height: 12%;
`;
const Circle = styled.div`
  border-radius: 50%;
  width: 100%;
  padding-bottom: 100%;
  background-color: ${(props) => (props.active ? 'green' : 'red')};
`;
const StatusWrapper = styled.div`
  display:flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
  justify-content: space-between;
`;


export default injectIntl(Tablet);
